import './slideSearchIcon.css';

function SlideSearchIcon(props) {
  const { icon } = props;
  return (
    <div className="search-wrapper">
      <div className="input-holder">
        <input
          type="text"
          className="search-input"
          placeholder="Type to search"
        />
        <button type="button" className="search-icon">
          <img src={icon} alt="searchIcon" />
        </button>
      </div>
    </div>
  );
}

export default SlideSearchIcon;
